import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StoryResult } from "../StoryInfoProxy";

interface State {
  stories: StoryResult[];
  isLoading: boolean;
}

const initialState: State = {
  stories: [],
  isLoading: false,
};

const storyDetailsSlice = createSlice({
  name: "storyDetails",
  initialState,
  reducers: {
    // Dispatched by the component on mount. Saga listens for this.
    loadStoryDetails: (state) => {
      state.isLoading = true;
    },
    // Dispatched by the saga once all API calls complete.
    storyDetailsLoaded: (state, action: PayloadAction<StoryResult[]>) => {
      state.stories = action.payload;
      state.isLoading = false;
    },
  },
});

export const { loadStoryDetails, storyDetailsLoaded } =
  storyDetailsSlice.actions;
export default storyDetailsSlice.reducer;
